export const TimeZone = "Europe/Stockholm";
